/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // HC - Show/hide images of a selected color variant - 12 June '23
  let swatches = [...document.querySelectorAll('.swatch__button')];
  let images = [...document.querySelectorAll('.product__slide')];
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function(){
      let value = this.querySelector('input').value;
      images.forEach(image => {
        if (image.dataset.color.includes(value)) {
          if(image.classList.contains('hidden')) {
            image.classList.remove('hidden');
          }
        } else {
          if(!image.classList.contains('hidden')) {
            image.classList.add('hidden');
          }
        }
      });
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
